<template>
  <!-- INFO: This Vue component is used for both large and compact breakpoints, and corresponds with 2 tag files: navUtilityBarB2cLargeContainer.tag and navUtilityBarB2cCompactContainer.tag  -->
  <div
    v-show="isShown"
    class="nav-utility-bar-b2c-container flex flex-col px-2 md:px-3 pb-3 lg:flex-row lg:justify-between lg:py-25"
    qaid="nav-utility-b2c"
  >
    <p v-if="isCompactView" class="nav-utility-bar-b2c-container__shop-text" v-html="bp('shopOurBrands')"></p>
    <div class="flex mt-3 flex-col lg:mt-0 lg:flex-row lg:items-center">
      <a
        v-for="logo in logos"
        :id="generateLogoId(logo.identifier)"
        :key="logo.identifier"
        :href="logo.href"
        :title="logo.title"
        class="flex mb-3 lg:mb-0 lg:mr-2"
      >
        <span
          :class="
            `nav-utility-bar-b2c-container__logo nav-utility-bar-b2c-container__logo--${logo.identifier} hover:opacity-100 lg:opacity-30`
          "
        />
        <span class="logo__heading" v-html="logo.heading" />
      </a>
    </div>

    <div class="nav-utility-bar-b2c-container__b2c-utilities">
      <!-- Profile & login info: -->
      <div class="mb-2 lg:mb-0 lg:mx-2 lg:order-2">
        <slot name="profile-login" />
      </div>

      <!-- Language & country info: -->
      <div>
        <slot name="language-country-info" />
      </div>

      <!-- Shopping cart: -->
      <div v-show="!isCompactView" class="order-last">
        <slot name="minicart" />
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'NavUtilityBarB2cContainer',
  props: {
    isLarge: {
      type: Boolean,
      default: false,
    },
    logos: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState('global', ['isCompactView']),
    isShown() {
      return this.isLarge ? !this.isCompactView : this.isCompactView;
    },
  },
  methods: {
    generateLogoId(logoId) {
      return this.isLarge ? `${logoId}'-large'` : `${logoId}'-compact'`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/settings/_settings-logos.scss';

.nav-utility-bar-b2c-container {
  // This insane z-index is to ensure that all contents of the utility bar are not covered by full-screen overlays when main navigation menu opens,
  // And are not overwritten by the other insane z-indexes coming from _navigation.scss
  // TODO: streamline the z-index madness in Phase 2!
  position: relative;
  z-index: 16000016; //needs to be less than reveal z-index: 16000017 in _custom.scss in order for the cart overlay in mobile to work

  &__logo {
    opacity: 0.5;
  }

  &__shop-text {
    @apply text-white;
    @apply text-lg;
    @apply font-medium;
    @apply mt-5;

    &::before {
      content: '';
      border-left: 2px solid var(--nav-highlight-color);
      margin-right: 0.5rem;
    }
  }

  &__logo--trek-logo {
    background-image: url('data:image/svg+xml, #{$trek-logo-white}');

    @include brand-logo(trek, 11px);

    @include breakpoint(large) {
      @include brand-logo(trek, 10px);
    }
  }

  &__logo--electra-logo {
    background-image: url('data:image/svg+xml, #{$electra-logo-white}');

    @include brand-logo(electra, 16px);

    @include breakpoint(large) {
      @include brand-logo(electra, 14px);
    }
  }

  &__logo--bontrager-logo {
    background-image: url('data:image/svg+xml, #{$bontrager-logo-white}');

    @include brand-logo(bontrager, 12px);

    @include breakpoint(large) {
      @include brand-logo(bontrager, 10px);
    }
  }

  &__logo--trek-travel-logo {
    background-image: url('data:image/svg+xml, #{$trek-travel-logo-white}');

    @include brand-logo(trek_travel, 11px);

    @include breakpoint(large) {
      @include brand-logo(trek_travel, 10px);
    }
  }

  &__b2c-utilities {
    display: flex;
    @apply flex-col;
    @apply mt-3;
    padding-bottom: 5rem;
    @include breakpoint(large) {
      @apply flex-row;
      @apply mt-0;
      @apply pb-0;
      @apply items-center;
    }
  }

  .header-bottom__cart-button {
    color: white;
    &:hover {
      opacity: 1;
    }
  }

  .logout-text {
    color: var(--gray-30);
  }
}
</style>
